import {Inject, injectable} from 'inversify-props';

import {IApiService} from '@/services/IApi.service';
import {ISystemLogService} from '@/services/system/ILog.service';

@injectable()
export class SystemLogService implements ISystemLogService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/system/log';

  public async getUserLog(): Promise<any> {
    return this.apiService.get(`${this.path}/user`, {
      timeout: 30000,
    });
  }

  public async getKernelLog(): Promise<any> {
    return this.apiService.get(`${this.path}/kernel`);
  }
}
